// WordPress returns taxonomy names HTML-escaped, e.g. "Art &amp; design".
// Decode before rendering so the UI never shows the entity.
export const decodeEntities = (html) => {
	if (!html) return "";
	const el = document.createElement("textarea");
	el.innerHTML = html;
	return el.value;
};

export default decodeEntities;
